import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { 
  doc, onSnapshot, updateDoc, collection, 
  setDoc, getDocs, deleteDoc, serverTimestamp, query, where, orderBy 
} from 'firebase/firestore';
import JogosLigaPK from './JogosLigaPK';
import { jogosDaJornada, construirCalendarioLiga } from './calendarioLiga';

function LigaPK() {
  // CONFIGURAÇÃO DE SALA INFINITA: O sistema agarra a Liga automática ativa
  const [idDaMinhaLiga, setIdDaMinhaLiga] = useState(null);
  
  const [abaAtiva, setAbaAtiva] = useState("classificacao"); // classificacao, jogos, caixa
  const [meusDados, setMeusDados] = useState(null);
  const [inscritos, setInscritos] = useState([]);
  const [dadosLiga, setDadosLiga] = useState(null);
  const [cashbackVIPBolas, setCashbackVIPBolas] = useState(0);
  const [jogoAtivoId, setJogoAtivoId] = useState(null);
  const [modoEspectador, setModoEspectador] = useState(false);
  const [chaveJornadaAtiva, setChaveJornadaAtiva] = useState('');

     // 🔍 DETETOR ATÓMICO DE LIGAS ROTATIVAS COM COORDENADA DIRETA NO PERFIL
   useEffect(() => {
     if (!auth.currentUser?.uid) return;

     const localizarOuCriarLiga = async () => {
       try {
         const { doc: fDoc, getDoc: fGetDoc, collection: fColl, getDocs: fGetDocs, query: fQuery, where: fWhere, limit: fLimit, addDoc: fAddDoc } = await import('firebase/firestore');
         
         // 🛡️ PASSO 0: LER O PERFIL DO UTILIZADOR PARA VER SE ELE JÁ ESTÁ NUMA LIGA EM ANDAMENTO
         const userRef = fDoc(db, "utilizadores", auth.currentUser.uid);
         const userSnap = await fGetDoc(userRef);
         const idLigaSalvo = userSnap.exists() ? userSnap.data()?.ligaPKAtivaId : null;

         if (idLigaSalvo) {
           // Se ele já tem uma liga registada no perfil, acopla o ecrã lá diretamente!
           setIdDaMinhaLiga(idLigaSalvo);
           return;
         }

         // 1. Se não está em nenhuma liga, procura uma livre com inscrições abertas
         const q = fQuery(fColl(db, "ligas_ativas"), fWhere("statusInscricao", "==", "abertas"), fLimit(1));
         const snap = await fGetDocs(q);

         if (!snap.empty) {
           // Encontrou uma liga livre! Acopla o ecrã ao ID dela
           setIdDaMinhaLiga(snap.docs[0].id);
         } else {
           // Tudo cheio ou nenhuma criada! Abre uma liga nova rotativa na hora
           const novaLigaDoc = await fAddDoc(fColl(db, "ligas_ativas"), {
             statusInscricao: "abertas",
             totalInscritos: 0,
             estadoCampeonato: "aguardando_jogadores",
             criadoEm: Date.now(),
             jornadaAtual: 1,
             poteAcumuladoBolas: 0
           });
           setIdDaMinhaLiga(novaLigaDoc.id);
         }
       } catch (errLiga) {
         console.error("Erro no motor de rotação de Ligas:", errLiga);
       }
     };

     localizarOuCriarLiga();
   }, []);

    // 1. ANTENA DE INFORMAÇÕES DA LIGA EM TEMPO REAL (CORREÇÃO DE SINCRONISMO)
  useEffect(() => {
    if (!idDaMinhaLiga) return; // 🛡️ Tranca: só liga o sensor quando o ID rodar!
    
    const unsub = onSnapshot(doc(db, "ligas_ativas", idDaMinhaLiga), (docSnap) => {
      if (docSnap.exists()) {
        setDadosLiga(docSnap.data());
      }
    }, (err) => console.error("Erro na Antena 1:", err));

    return () => unsub();
  }, [idDaMinhaLiga]);

  // 2. ANTENA DOS JOGADORES INSCRITOS (A QUE FAZ AS FOTOS APARECEREM NA ESTEIRA!)
  useEffect(() => {
    if (!idDaMinhaLiga) return;
    
    // 🚀 ALVO DE ELITE: Lê síncronamente a subcoleção exata da liga rotativa ativa
    const q = query(collection(db, "ligas_ativas", idDaMinhaLiga, "inscritos"));
    
    const unsub = onSnapshot(q, (snap) => {
      const listaInscritos = snap.docs.map(d => d.data());
      setInscritos(listaInscritos);
    }, (err) => console.error("Erro na Antena 2:", err));

    return () => unsub();
  }, [idDaMinhaLiga]);

    // // 3. ANTENA FINANCEIRA DO POTE DA LIGA
  useEffect(() => {
    if (!idDaMinhaLiga) return;

    // 🚀 CORREÇÃO DEFINITIVA: Aponta para o documento mestre da liga (2 segmentos válidos)
    const unsubPote = onSnapshot(doc(db, "ligas_ativas", idDaMinhaLiga), (docSnap) => {
      if (docSnap.exists()) {
        setPoteBolas(docSnap.data().poteAcumuladoBolas || 0);
        setCashbackVIPBolas(docSnap.data().cashbackAcumuladoBolas || 0);
      }
    }, (err) => console.error("Erro na Antena 3:", err));

    return () => unsubPote();
  }, [idDaMinhaLiga]);

  // 4. LEITURA DOS DADOS DO UTILIZADOR LOGADO
  useEffect(() => {
    if (!auth.currentUser) return;
    const unsub = onSnapshot(doc(db, "utilizadores", auth.currentUser.uid), (snap) => {
      setMeusDados(snap.data());
    });
    return () => unsub();
  }, []);

    // MOTOR DE INSCRIÇÃO AUTOMÁTICA (CARIMBADOR DE COORDENADAS)
  const inscreverNaLiga = async () => {
    if (!idDaMinhaLiga) {
      alert("A aguardar ligação com o servidor da Liga... Tenta em 2 segundos! ⏳");
      return;
    }
    try {
      const salaInscritosRef = collection(db, "ligas_ativas", idDaMinhaLiga, "inscritos");
      const snapInscritos = await getDocs(salaInscritosRef);
      
      const jaInscrito = snapInscritos.docs.some(d => d.id === auth.currentUser.uid);
      if (jaInscrito) {
        alert("Já estás inscrito nesta Liga! ⚽");
        return;
      }

      if (snapInscritos.size >= 10) {
        alert("Esta Liga acabou de encher! O sistema já está a criar uma nova liga. ⏳");
        return;
      }

      const meuDocRef = doc(db, "ligas_ativas", idDaMinhaLiga, "inscritos", auth.currentUser.uid);
      const novosInscritosLista = snapInscritos.docs.map(d => d.data());
      
      const dadosMeusInscrito = {
        uid: auth.currentUser.uid,
        nome: meusDados?.nomeCompleto || auth.currentUser?.displayName || "Craque",
        foto: meusDados?.fotoUrl || auth.currentUser?.photoURL || '',
        pontosTabela: 0,
        vitorias: 0,
        empates: 0,
        derrotas: 0,
        totalMoedasGanhasCompeticao: 0,
        inscritoEm: Date.now()
      };

      // 1. Grava o jogador dentro da liga ativa
      await setDoc(meuDocRef, dadosMeusInscrito);
      
      // 🚀 CORREÇÃO CRÍTICA: Salva o ID da liga no perfil do utilizador para fixar o radar!
      await setDoc(doc(db, "utilizadores", auth.currentUser.uid), { ligaPKAtivaId: idDaMinhaLiga }, { merge: true });
      
      novosInscritosLista.push(dadosMeusInscrito);
      const novaContagem = snapInscritos.size + 1;

      if (novaContagem === 10) {
        const estruturaCalendario = construirCalendarioLiga(novosInscritosLista);

        // Tranca a liga atual como em andamento
        await setDoc(doc(db, "ligas_ativas", idDaMinhaLiga), {
          statusInscricao: "fechadas",
          estadoCampeonato: "em_andamento",
          totalInscritos: 10,
          jornadas: estruturaCalendario.jornadas,
          totalJornadas: estruturaCalendario.totalJornadas,
          jornadaAtual: 1,
          atualizadoEm: Date.now()
        }, { merge: true });

        alert("Parabéns! Foste o 10º inscrito. A Liga PK está OFICIALMENTE LANÇADA! 🏆⚽");
      } else {
        await setDoc(doc(db, "ligas_ativas", idDaMinhaLiga), {
          totalInscritos: novaContagem,
          estadoCampeonato: "aguardando_jogadores"
        }, { merge: true });

        alert(`Inscrição confirmada! Somos agora ${novaContagem}/10 jogadores. 🏆`);
      }

    } catch (e) { 
      console.error("Erro crítico na inscrição:", e);
      alert("Erro ao gravar. Verifica a internet e tenta de novo! ⚽");
    }
  };

  // BOTÃO VERMELHO DE DESISTÊNCIA SEGURA (SAIR DA FILA DINÂMICA)
  const desistirVagaLiga = async () => {
    if (!idDaMinhaLiga) return;
    try {
      // 🚀 CORRIGIDO: Apaga síncronamente o registo da coleção dinâmica ativa
      await deleteDoc(doc(db, "ligas_ativas", idDaMinhaLiga, "inscritos", auth.currentUser.uid));
      
      const salaInscritosRef = collection(db, "ligas_ativas", idDaMinhaLiga, "inscritos");
      const snapInscritos = await getDocs(salaInscritosRef);
      const novaContagem = snapInscritos.size;

      // Atualiza o contador de vagas real da liga no Firebase
      await setDoc(doc(db, "ligas_ativas", idDaMinhaLiga), {
        totalInscritos: novaContagem,
        estadoCampeonato: novaContagem === 0 ? "aguardando_jogadores" : "aguardando_jogadores"
      }, { merge: true });

      alert("Vaga libertada com sucesso! Saíste da fila. ✕");
    } catch (e) { 
      console.error("Erro ao desistir da vaga:", e); 
    }
  };

      // 🚀 ALVO DE ELITE: Correção atómica de nomenclatura de variáveis (Tudo unificado em jogo!)
  const entrarNoJogoDaLiga = async (jogo, chaveJornada) => {
    if (!jogo) return;
    const souJogador = jogo.p1?.uid === auth.currentUser?.uid || jogo.p2?.uid === auth.currentUser?.uid;
    
    if (souJogador) {
      try {
        const { doc: fDoc, getDoc: fGetDoc, setDoc: fSetDoc } = await import('firebase/firestore');
        const partidaRef = fDoc(db, "batalhasAtivas_liga", jogo.idJogo);
        const snapPartida = await fGetDoc(partidaRef);

        if (!snapPartida.exists()) {
          await fSetDoc(partidaRef, {
            fase: "ESPERA",
            status: "pendente",
            tempo: 300,
            idA: jogo.p1.uid,
            idB: jogo.p2?.uid || "",
            nomeA: jogo.p1.nome || "Jogador A",
            nomeB: jogo.p2?.nome || "Jogador B",
            fotoA: jogo.p1.foto || "",
            fotoB: jogo.p2?.foto || "",
            pontosA: 0,
            pontosB: 0,
            prontoA: false,
            prontoB: false,
            totalTapTaps: 0,
            claqueAtivosA: 0,
            claqueAtivosB: 0,
            poteBolasJogo: 0
          });
        }
      } catch (errCreate) {
        console.error("Erro ao gerar aquecimento da partida:", errCreate);
      }
    }

    setChaveJornadaAtiva(chaveJornada);
    setJogoAtivoId(jogo.idJogo);
    setModoEspectador(!souJogador);
  };

  // GATILHO DE DIRECIONAMENTO PARA O CAMPO DE JOGO
  if (jogoAtivoId) {
    return (
      <JogosLigaPK 
        idLiga={idDaMinhaLiga}
        chaveJornada={chaveJornadaAtiva}
        idJogoNaJornada={jogoAtivoId}
        idBatalha={jogoAtivoId}
        espectador={modoEspectador}
        aoSair={() => setJogoAtivoId(null)}
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', color: 'white', padding: '15px', paddingBottom: '90px', textAlign: 'center' }}>
      {/* CABEÇALHO DOURADO NÉON */}
      <div style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#FFD700', fontWeight: '900', fontSize: '24px', margin: '0', letterSpacing: '2px', textShadow: '0 0 10px rgba(255, 215, 0, 0.3)' }}>
          LIGA PK ARENA ⚽
        </h2>
      </div>

          {/* PAINEL DE INSCRIÇÃO AUTOMÁTICA EM ESTEIRA */}
      {(!dadosLiga || dadosLiga.estadoCampeonato === "aguardando_jogadores") && (
        <div style={{ background: '#111', padding: '25px', borderRadius: '20px', border: '1px solid #FFD700', marginBottom: '20px' }}>
          <h3 style={{ color: '#FFD700', fontSize: '16px', marginBottom: '10px' }}>SALA DE ESPERA: {inscritos.length} / 10 JOGADORES</h3>
          <p style={{ color: '#aaa', fontSize: '11px', marginBottom: '20px' }}>Mal as 10 vagas fechem, o calendário de 45 jogos da Liga PK arranca automaticamente!</p>
          
          {!inscritos.find(i => i.uid === auth.currentUser?.uid) ? (
            inscritos.length < 10 && (
              <button onClick={inscreverNaLiga} style={{ background: '#FFD700', color: 'black', border: 'none', padding: '15px 35px', borderRadius: '15px', fontWeight: '900', fontSize: '14px', cursor: 'pointer', boxShadow: '0 0 15px rgba(255, 215, 0, 0.4)', width: '90%' }}>
                GARANTIR MINHA VAGA 🏆
              </button>
            )
          ) : (
            <button onClick={desistirVagaLiga} style={{ background: '#ff4444', color: 'white', border: 'none', padding: '15px 35px', borderRadius: '15px', fontWeight: '900', fontSize: '14px', cursor: 'pointer', boxShadow: '0 0 15px rgba(255, 68, 68, 0.3)', width: '90%' }}>
              ✕ DESISTIR DA VAGA
            </button>
          )}

          {/* LISTA COMPACTA DE INSCRITOS */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '8px', marginTop: '20px' }}>
            {inscritos.map(i => (
              <img key={i.uid} src={i.foto || '/hero.png'} style={{ width: '32px', height: '32px', borderRadius: '50%', border: '1px solid #FFD700', objectFit: 'cover' }} onError={(e) => { e.target.src = '/hero.png'; }} alt="P" />
            ))}
          </div>
        </div>
      )}

    {/* SE A LIGA JÁ COMEÇOU, MOSTRA O PAINEL DE NAVEGAÇÃO POR ABAS */}
      {dadosLiga && dadosLiga.estadoCampeonato === "em_andamento" && (
        <>
          {/* ABAS NÉON */}
          <div style={{ display: 'flex', background: '#111', borderRadius: '12px', padding: '4px', marginBottom: '20px', border: '1px solid #222' }}>
            <button onClick={() => setAbaAtiva("classificacao")} style={{ flex: 1, background: abaAtiva === "classificacao" ? "#FFD700" : "none", color: abaAtiva === "classificacao" ? "black" : "white", border: 'none', padding: '10px', borderRadius: '8px', fontWeight: '900', fontSize: '11px', cursor: 'pointer' }}>📈 TABELA</button>
            <button onClick={() => setAbaAtiva("jogos")} style={{ flex: 1, background: abaAtiva === "jogos" ? "#39FF14" : "none", color: abaAtiva === "jogos" ? "black" : "white", border: 'none', padding: '10px', borderRadius: '8px', fontWeight: '900', fontSize: '11px', cursor: 'pointer' }}>📅 JORNADA {dadosLiga.jornadaAtual} / {dadosLiga.totalJornadas}</button>
            <button onClick={() => setAbaAtiva("caixa")} style={{ flex: 1, background: abaAtiva === "caixa" ? "#00FFFF" : "none", color: abaAtiva === "caixa" ? "black" : "white", border: 'none', padding: '10px', borderRadius: '8px', fontWeight: '900', fontSize: '11px', cursor: 'pointer' }}>⚽ BOLAS</button>
          </div>

          {/* CONTEÚDO 1: TABELA CLASSIFICATIVA (COM COLUNA DE DESEMPATE DE MOEDAS) */}
          {abaAtiva === "classificacao" && (
                        <div style={{ background: '#111', borderRadius: '15px', padding: '10px', width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', boxSizing: 'border-box' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', textAlign: 'left' }}>
              <thead>
                  <tr style={{ borderBottom: '1px solid #333', color: '#FFD700' }}>
                    <th style={{ padding: '8px' }}>P.</th>
                    <th style={{ padding: '8px' }}>NOME</th>
                    <th style={{ padding: '8px', textAlign: 'center' }}>PTS</th>
                    {/* ⚽ UNIFICADO: Alinhado síncronamente com a moeda oficial da tua PWA! */}
                    <th style={{ padding: '8px', textAlign: 'center' }}>BOLAS</th>
                    <th style={{ padding: '8px', textAlign: 'center' }}>V</th>
                    <th style={{ padding: '8px', textAlign: 'center' }}>E</th>
                    <th style={{ padding: '8px', textAlign: 'center' }}>D</th>
                  </tr>
                </thead>
                <tbody>
                              {[...inscritos].sort((a, b) => {
                // 1. CRITÉRIO REGULAMENTAR: Maior número de pontos na tabela
                if ((b.pontosTabela || 0) !== (a.pontosTabela || 0)) {
                  return (b.pontosTabela || 0) - (a.pontosTabela || 0);
                }
                // 2. CRITÉRIO MESTRE DE DESEMPATE: Maior volume de Bolas ganhas na competição
                if ((b.totalMoedasGanhasCompeticao || 0) !== (a.totalMoedasGanhasCompeticao || 0)) {
                  return (b.totalMoedasGanhasCompeticao || 0) - (a.totalMoedasGanhasCompeticao || 0);
                }
                // 3. CRITÉRIO SECUNDÁRIO: Maior número de vitórias acumuladas
                if ((b.vitorias || 0) !== (a.vitorias || 0)) {
                  return (b.vitorias || 0) - (a.vitorias || 0);
                }
                // 4. ÚLTIMO RECURSO: Ordem cronológica de inscrição (mais antigo primeiro)
                return (a.inscritoEm || 0) - (b.inscritoEm || 0);
              }).map((jog, index) => (

                    <tr key={jog.uid} style={{ borderBottom: '1px solid #222', background: jog.uid === auth.currentUser?.uid ? 'rgba(255,215,0,0.05)' : 'none' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold', color: index < 2 ? '#39FF14' : 'white' }}>{index + 1}º</td>
                      <td style={{ padding: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <img src={jog.foto || '/hero.png'} style={{ width: '22px', height: '22px', borderRadius: '50%' }} onError={(e) => { e.target.src = '/hero.png'; }} alt="Avatar" />
                        <span style={{ fontWeight: 'bold', maxWidth: '75px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{jog.nome ? jog.nome.split(' ')[0] : "Craque"}</span>
                      </td>
                      <td style={{ padding: '10px', textAlign: 'center', fontWeight: '900', color: '#FFD700' }}>{jog.pontosTabela || 0}</td>
                      {/* 🚀 NOVA COLUNA: Mostra o acumulado da Tranca A de desempate em tempo real */}
                      <td style={{ padding: '10px', textAlign: 'center', fontWeight: 'bold', color: '#00FFFF', fontFamily: 'monospace' }}>{(jog.totalMoedasGanhasCompeticao || 0).toLocaleString()}</td>
                      <td style={{ padding: '10px', textAlign: 'center', color: '#aaa' }}>{jog.vitorias || 0}</td>
                      <td style={{ padding: '10px', textAlign: 'center', color: '#aaa' }}>{jog.empates || 0}</td>
                      <td style={{ padding: '10px', textAlign: 'center', color: '#aaa' }}>{jog.derrotas || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

                  {/* CONTEÚDO 2: JOGOS DA JORNADA (BOTÕES INDIVIDUAIS LADO A LADO ESTILO CHAMPIONS PK - EXTRAÇÃO DO FIRESTORE ATÓMICA) */}
          {abaAtiva === "jogos" && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: '65vh', overflowY: 'auto', paddingRight: '4px', boxSizing: 'border-box' }}>
              {(() => {
                const chaveJornada = `jornada_${dadosLiga?.jornadaAtual || 1}`;
                const mapaJogosObjeto = dadosLiga?.jornadas?.[chaveJornada] || {};
                const listaJogosJornada = Object.values(mapaJogosObjeto);

                return listaJogosJornada.map((jg) => {
                  return (
                    <div key={jg.idJogo} style={{ background: '#111', border: '1px solid #222', borderRadius: '15px', padding: '12px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      
                      {/* LINHA SUPERIOR: AVATARES E PLACAR DE BOLAS */}
                      <div style={{ display: 'flex', justifyContent: 'space-around', padding: '0 5px', alignItems: 'center' }}>
                        <div style={{ textAlign: 'center', flex: 1 }}>
                          <img src={jg.p1?.foto || '/hero.png'} style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1.5px solid #ff4444' }} onError={(e) => { e.target.src = '/hero.png'; }} alt="P1" />
                          <div style={{ fontSize: '10px', marginTop: '4px', fontWeight: 'bold', color: '#fff' }}>{jg.p1?.nome ? jg.p1.nome.split(' ')[0] : "Jogador 1"}</div>
                        </div>
                        
                        <div style={{ background: '#222', padding: '6px 14px', borderRadius: '10px', fontSize: '14px', fontWeight: '950', color: '#39FF14', fontFamily: 'monospace', border: '1px solid #333' }}>
                          {jg.pontosP1?.toLocaleString() || 0} - {jg.pontosP2?.toLocaleString() || 0}
                        </div>
                        
                        <div style={{ textAlign: 'center', flex: 1 }}>
                          <img src={jg.p2?.foto || '/hero.png'} style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1.5px solid #4444ff' }} onError={(e) => { e.target.src = '/hero.png'; }} alt="P2" />
                          <div style={{ fontSize: '10px', marginTop: '4px', fontWeight: 'bold', color: '#fff' }}>{jg.p2?.nome ? jg.p2.nome.split(' ')[0] : "Jogador 2"}</div>
                        </div>
                      </div>
                      
                      {/* 🚀 LINHA INFERIOR DE BOTÕES: DUPLOS E INDIVIDUAIS (RÉPLICA FIEL CHAMPIONS PK - RESTRITO A 2 BOTÕES) */}
                      <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
        
                              {/* BOTÃO DO JOGADOR DA ESQUERDA (P1 - COLUNA DO JOGADOR A) */}
                      {(() => {
                        const jogoEncerrado = jg.status !== 'pendente' || jg.status === 'concluido' || jg.finalizado === true;
                        const meuUid = auth.currentUser?.uid;
                        const euSouEsteJogador = meuUid && jg.p1?.uid === meuUid;
                        const euSouOAdversario = meuUid && jg.p2?.uid === meuUid;

                        if (jogoEncerrado) {
                          return (
                            <button disabled style={{ flex: 1, background: '#1c1c1c', color: '#555', border: '1px solid #282828', borderRadius: '8px', padding: '8px', fontSize: '10px', fontWeight: '900', cursor: 'default', textTransform: 'uppercase' }}>
                              TERMINADO 🏁
                            </button>
                          );
                        }

                        // Se a coluna sou EU, acendo o meu combate
                        if (euSouEsteJogador) {
                          return (
                            <button 
                              onClick={() => entrarNoJogoDaLiga(jg, `jornada_${dadosLiga.jornadaAtual}`)}
                              style={{ flex: 1, background: 'linear-gradient(135deg, #FF8C00 0%, #FFD700 100%)', color: 'black', border: 'none', borderRadius: '8px', padding: '8px', fontSize: '10px', fontWeight: '900', cursor: 'pointer', textTransform: 'uppercase', boxShadow: '0 0 8px rgba(255, 215, 0, 0.2)' }}
                            >
                              ⚔️ JOGAR PK
                            </button>
                          );
                        }

                        // Se a coluna é o meu rival, tranca a dizer para eu aguardar
                        if (euSouOAdversario) {
                          return (
                            <button disabled style={{ flex: 1, background: '#222', color: '#888', border: '1px solid #333', borderRadius: '8px', padding: '8px', fontSize: '10px', fontWeight: '900', cursor: 'default', textTransform: 'uppercase' }}>
                              AGUARDA ⏳
                            </button>
                          );
                        }

                        // Se eu sou público comum nas bancadas, assisto à partida
                        return (
                          <button 
                            onClick={() => entrarNoJogoDaLiga(jg, `jornada_${dadosLiga.jornadaAtual}`)}
                            style={{ flex: 1, background: '#39FF14', color: 'black', border: 'none', borderRadius: '8px', padding: '8px', fontSize: '10px', fontWeight: '900', cursor: 'pointer', textTransform: 'uppercase' }}
                          >
                            👁️ ASSISTIR
                          </button>
                        );
                      })()}

                      {/* BOTÃO DO JOGADOR DA DIREITA (P2 - COLUNA DO JOGADOR B) */}
                      {(() => {
                        const jogoEncerrado = jg.status !== 'pendente' || jg.status === 'concluido' || jg.finalizado === true;
                        const meuUid = auth.currentUser?.uid;
                        const euSouEsteJogador = meuUid && jg.p2?.uid === meuUid;
                        const euSouOAdversario = meuUid && jg.p1?.uid === meuUid;

                        if (jogoEncerrado) {
                          return (
                            <button disabled style={{ flex: 1, background: '#1c1c1c', color: '#555', border: '1px solid #282828', borderRadius: '8px', padding: '8px', fontSize: '10px', fontWeight: '900', cursor: 'default', textTransform: 'uppercase' }}>
                              TERMINADO 🏁
                            </button>
                          );
                        }

                        // Se a coluna sou EU, acendo o meu combate
                        if (euSouEsteJogador) {
                          return (
                            <button 
                              onClick={() => entrarNoJogoDaLiga(jg, `jornada_${dadosLiga.jornadaAtual}`)}
                              style={{ flex: 1, background: 'linear-gradient(135deg, #FF8C00 0%, #FFD700 100%)', color: 'black', border: 'none', borderRadius: '8px', padding: '8px', fontSize: '10px', fontWeight: '900', cursor: 'pointer', textTransform: 'uppercase', boxShadow: '0 0 8px rgba(255, 215, 0, 0.2)' }}
                            >
                              ⚔️ JOGAR PK
                            </button>
                          );
                        }

                        // Se a coluna é o meu rival, tranca a dizer para eu aguardar
                        if (euSouOAdversario) {
                          return (
                            <button disabled style={{ flex: 1, background: '#222', color: '#888', border: '1px solid #333', borderRadius: '8px', padding: '8px', fontSize: '10px', fontWeight: '900', cursor: 'default', textTransform: 'uppercase' }}>
                              AGUARDA ⏳
                            </button>
                          );
                        }

                        // Se eu sou público comum nas bancadas, assisto à partida
                        return (
                          <button 
                            onClick={() => entrarNoJogoDaLiga(jg, `jornada_${dadosLiga.jornadaAtual}`)}
                            style={{ flex: 1, background: '#39FF14', color: 'black', border: 'none', borderRadius: '8px', padding: '8px', fontSize: '10px', fontWeight: '900', cursor: 'pointer', textTransform: 'uppercase' }}
                          >
                            👁️ ASSISTIR
                          </button>
                        );
                      })()}

                    </div>

                  </div>
                   );
                });
              })()}
            </div>
          )}

        {/* CONTEÚDO 3: BANNER DO POTE DA COMPETIÇÃO E RECOMPENSA FINANCEIRA */}
          {abaAtiva === "caixa" && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ background: 'linear-gradient(180deg, #111, #000)', border: '2px solid #FFD700', borderRadius: '20px', padding: '20px', textAlign: 'center', boxShadow: '0 0 25px rgba(255, 215, 0, 0.1)' }}>
                {/* 🚀 ATUALIZADO: Agora exclusivo para os dois Finalistas (75% / 25%) */}
                <p style={{ color: '#aaa', fontSize: '10px', margin: 0, fontWeight: 'bold', letterSpacing: '2px' }}>GRANDE POTE DO CAMPEONATO (FINALISTAS 75/25)</p>
                <h1 style={{ color: '#FFD700', fontSize: '36px', margin: '8px 0', fontWeight: '900', textShadow: '0 0 15px rgba(255, 215, 0, 0.4)', fontFamily: 'monospace' }}>
                  {Math.round(dadosLiga?.poteAcumuladoBolas || 0).toLocaleString()} ⚽
                </h1>
                <span style={{ color: '#39FF14', fontSize: '10px', fontWeight: 'bold' }}>● 15% DE CADA ITEM ADICIONADO AO POTE EXCLUSIVO DO TOP 2 DA PLATAFORMA 📈</span>
              </div>

              <div style={{ background: 'linear-gradient(180deg, #111, #000)', border: '2px solid #00FFFF', borderRadius: '20px', padding: '20px', textAlign: 'center', boxShadow: '0 0 25px rgba(0, 255, 255, 0.1)' }}>
                <p style={{ color: '#aaa', fontSize: '10px', margin: 0, fontWeight: 'bold', letterSpacing: '2px' }}>RECOMPENSA DE INCENTIVO DA JORNADA</p>
                <h1 style={{ color: '#00FFFF', fontSize: '32px', margin: '8px 0', fontWeight: '900', textShadow: '0 0 15px rgba(0, 255, 255, 0.4)', fontFamily: 'monospace' }}>
                  {Math.round((dadosLiga?.poteAcumuladoBolas || 0) * 0.05).toLocaleString()} <span style={{ fontSize: '14px' }}>⚽ Bolas</span>
                </h1>
                <span style={{ color: '#00FFFF', fontSize: '10px', fontWeight: 'bold' }}>🔥 5% DE RETORNO À MEIA-NOITE PARA O MAIOR INVESTIDOR DE CROMOS! 🔥</span>
              </div>
            </div>
          )}
        </>
      )}

      {/* BARRA FIXA DE RETORNO AO PERFIL */}
      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, height: '75px', backgroundColor: '#111', borderTop: '1px solid #333', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
        <button onClick={() => window.history.back()} style={{ background: 'none', border: 'none', color: '#FFD700', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
          <span style={{ fontSize: '24px', marginBottom: '4px' }}>👤</span>
          <span style={{ fontSize: '10px', fontWeight: '900', letterSpacing: '1px' }}>VOLTAR AO PERFIL</span>
        </button>
      </div>

    </div>
  );
}

export default LigaPK;
